import Notification from "@scripts/modules/Notification";
import imgSuccess from '@images/icons/success.svg';
import imgError from '@images/icons/error.svg';

const successForm = `
    <h5 class="note-title flex_c">
        <img class="note-img" src="${imgSuccess}" alt="Success">
        Мы получили сообщение
    </h5>
    <p class="note-text">Спасибо! Мы получили сообщение и свяжемся с вами в ближайшее время</p>
`;

const unsuccessForm = `
    <h5 class="note-title flex_c">
        <img class="note-img" src="${imgError}" alt="Error">
        Что-то пошло не так...
    </h5>
    <p class="note-text">Мы уже исправляем это! А пока напишите нам в мессенджерах или соц. сетях</p>
    <div class="socials socials_basic flex_c th_dark"> 
        <a class="socials__item vi-round" href="https://t.me/ppekzofficial", target="_blank"><i class="i-telegram"></i></a>
        <a class="socials__item vi-round" href="https://wa.me/77058615980", target="_blank"><i class="i-whatsapp"></i></a>
        <a class="socials__item vi-round" href="https://www.instagram.com/ppe.kz/", target="_blank"><i class="i-instagram"></i></a>
        <a class="socials__item vi-round" href="https://www.facebook.com/www.ppe.kz/", target="_blank"><i class="i-facebook"></i></a>
    </div>
`;

function createInstanceNotification(content) {
    return new Notification({
        selector: '#notification',
        content: content,
        close: '#notification .close',
        overlay: '#notification .ov_offcanvas_center'
    })
}

export {
    successForm,
    unsuccessForm,
    createInstanceNotification
}